import { IAPIState } from "./Notifyapi";


export function getApiInitState(): IAPIState {
    return {
        error: "",
        isLoading: false,
        status: false,
        refresh: false,
    };
}

export function getApiLoadingState(): IAPIState {
    return {
        error: "",
        isLoading: true,
        status: false,
        refresh: false,
    };
}
export function getCurrentLocalTime() {
    const now = new Date();
    const day = now.getDate().toString().padStart(2, "0");
    const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based
    const year = now.getFullYear();
    const hours = (now.getHours() > 12 ? now.getHours() - 12 : now.getHours())
        .toString()
        .padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const seconds = now.getSeconds().toString().padStart(2, "0");
    const ampm = now.getHours() >= 12 ? "PM" : "AM";

    const formattedTime = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    return formattedTime;
}
export function getApiSuccessState(): IAPIState {
    return {
        error: "",
        isLoading: false,
        status: true,
        refresh: false,
        refreshOn: getCurrentLocalTime(),
    };
}

export function getApiFailState(): IAPIState {
    return {
        error: "",
        isLoading: false,
        status: false,
        refresh: false,
        refreshOn: getCurrentLocalTime(),
    };
}